

























































































import Vue from "vue";
import coreApiClient from "@/services/apis/coreApiClient";
import configProvider from "@common/services/configProvider";
import GlobalErrorSnackBar from "@/components/GlobalErrorSnackBar.vue";
import ResetPasswordOtpDialog from "@/components/ResetPasswordOtpDialog.vue";

export default Vue.extend({
  components: { GlobalErrorSnackBar, ResetPasswordOtpDialog },
  data() {
    return {
      valid: false,
      loading: false,
      error: "",
      ruleRequired: (value) => !!value || this.$t("REQUIRED"),
      logoUrl: configProvider.get("LOGO_URL"),
      data: {} as any,
      showOtpDialog: false,
      resetPhone: "",
      resetEmail: "",
    };
  },
  methods: {
    async submit() {
      this.error = "";
      this.loading = true;
      try {
        const isPhone = /^[0-9]+$/.test(this.data.identifier);
        const payload = isPhone 
          ? { phone: this.data.identifier }
          : { email: this.data.identifier };
        
        const result = await coreApiClient.callRaw(
          "auth",
          "forgotPassword",
          undefined,
          payload
        );
        
        if (result && typeof result === "object" && result.type === "sms") {
          if (isPhone) {
            this.resetPhone = this.data.identifier;
          } else {
            this.resetEmail = this.data.identifier;
          }
          this.showOtpDialog = true;
          this.loading = false;
          return;
        }
        
        if (result) {
          alert(
            "An email has been sent to your email address. Please check your email to reset your password."
          );
          this.$router.replace("/login");
        }
      } catch (err) {
        const theErr = err as any;
        if (theErr.response?.body?.message) {
          this.error = theErr.response.body.message;
        } else {
          this.error = err;
        }
      } finally {
        this.loading = false;
      }
    },
    
    onPasswordReset() {
      alert("Password reset successfully!");
      this.$router.replace("/login");
    },
    
    onOtpDialogClose() {
      this.showOtpDialog = false;
    },
  },
});
